import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DatosMaestrosService} from "../../../../services/datos-maestros.service";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {moduloAutoconsumo} from "../../diccionarios/autoconsumoModulo";
import {forkJoin} from "rxjs";
import {AutoconsumoMotivoPedidoService} from "../../services/autoconsumo-motivo-pedido.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {AutoconsumoModalService} from "../../services/modal.service";

@Component({
  selector: 'app-motivo-pedido',
  templateUrl: './motivo-pedido.component.html',
  styleUrls: ['./motivo-pedido.component.css']
})
export class MotivoPedidoComponent implements OnInit {
  mostrarFormulario: boolean = false;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioEditar: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbCuentaContable: any[];
  cmbMotivoPedido: any[];
  cmbSectorVenta: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  labelCuentaContableInfo: any;


  constructor(
    private fb: FormBuilder,
    private _autoconsumoMotivoPedidoService: AutoconsumoMotivoPedidoService,
    private _datosMaestrosService: DatosMaestrosService,
    private _util: UtilsService,
    private _autoconsumoModalService: AutoconsumoModalService
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloAutoconsumo.button.buttonsNombre;
    this.DAT_TITULOS = moduloAutoconsumo.titulos.autoconsumoMotivoPedido;
    this.DAT_BTNCSS = moduloAutoconsumo.button.buttonsCss;
    this.DAT_MSG = moduloAutoconsumo.mensajes;
    this.textBoton = moduloAutoconsumo.button.buttonsNombre.agregar;
    this.titulo = this.DAT_TITULOS.titulo;
    this.formulario = this.fb.group({
      idMotivoPedido: ['', Validators.required],
      ctaContable: ['', [Validators.required]],
    });

    this.formularioEditar =  this.fb.group({
      idMotivoPedido: ['', Validators.required],
      ctaContable: ['', [Validators.required]],
      desCtaContable: ['', []],
      oldIdMotivoPedido: ['', []],
    });
    this.getFormInfo();
    this.girdComponent();

    this._autoconsumoModalService.getModalEvent().subscribe(data => {
      //console.log(data);
      if (data && data.data) {
        this.formulario.get('ctaContable').setValue(data.data.id);
        this.labelCuentaContableInfo = data.data.id + ' - ' + data.data.cuentaContable;
        document.getElementById('closeModal').click();
      }
    });
  }


  getAllAutoconsumoMotivoPedido() {
    this.loading = true;
    this._autoconsumoMotivoPedidoService.getAllMotivoPedido().subscribe((res: any) => {
      res.map(autoconsumoMotivoPedido => {
        autoconsumoMotivoPedido.descripcionMotivoPedido = autoconsumoMotivoPedido.idMotivoPedido + ' | ' + autoconsumoMotivoPedido.dscaMotivoPedido;
        autoconsumoMotivoPedido.descripcionCuentaContable = autoconsumoMotivoPedido.ctaContable + ' | ' + autoconsumoMotivoPedido.dscaCuentaContable;
      });
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'MOTIVO PEDIDO',
        field: 'descripcionMotivoPedido',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'CUENTA CONTABLE',
        field: 'descripcionCuentaContable',
        sortable: true,
        filter: true,
        width: 400
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.arbrirModalDetalle.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  eliminar({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._autoconsumoMotivoPedidoService.borrarMotivoPedido(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    });
  }

  getFormInfo() {
    this.loading = true;
    const _getAllMotivoPedido = this._datosMaestrosService.getAllMotivoPedido();
    const _getAllAutoconsumoMotivoPedido = this._autoconsumoMotivoPedidoService.getAllMotivoPedido();


    forkJoin([_getAllMotivoPedido, _getAllAutoconsumoMotivoPedido]).subscribe((res: any) => {
      res[0].map(motivoPedido => {
        motivoPedido.id = motivoPedido.idMotivoPedido;
        motivoPedido.descripcion = motivoPedido.idMotivoPedido + ' | ' + motivoPedido.dscaMotivoPedido;
      });
      res[1].map(autoconsumoMotivoPedido => {
        autoconsumoMotivoPedido.descripcionMotivoPedido = autoconsumoMotivoPedido.idMotivoPedido + ' | ' + autoconsumoMotivoPedido.dscaMotivoPedido;
        autoconsumoMotivoPedido.descripcionCuentaContable = autoconsumoMotivoPedido.ctaContable + ' | ' + autoconsumoMotivoPedido.dscaCuentaContable;
      });

      this.cmbMotivoPedido = res[0];
      this.rowData = res[1];
      this.loading = false;
    }, () => {
      this.loading = false;
      this.cmbMotivoPedido = [];
      this.rowData = [];
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
      } else {
        this.guardarMotivoPedido();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
    }
  }


  guardarMotivoPedido() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._autoconsumoMotivoPedidoService.creacionMotivoPedido(this.formulario.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllAutoconsumoMotivoPedido();
    });
  }

  openModalCuentaContable() {
    document.getElementById('abrirModalCuentaContable').click();
  }

  closeModalCuentaContable() {
    // Suponiendo que tienes un botón de cierre en el modal con el id 'cerrarModalCuentaContable'
    document.getElementById('cerrarModalDetalle').click();
  }

  arbrirModalDetalle({ rowData }) {
    this.formularioEditar.get('desCtaContable').setValue(rowData.descripcionCuentaContable);
    this.formularioEditar.get('ctaContable').setValue(rowData.ctaContable);
    this.formularioEditar.get('idMotivoPedido').setValue(rowData.idMotivoPedido);
    this.formularioEditar.get('oldIdMotivoPedido').setValue(rowData.idMotivoPedido);
    document.getElementById('arbrirModalDetalle').click();
    console.log(rowData)
  }

  ActualizaMotivoPedido() {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._autoconsumoMotivoPedidoService.actualizarMotivoPedido(this.formularioEditar.value),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllAutoconsumoMotivoPedido();
      this.closeModalCuentaContable();
    });
  }

}
